/* eslint-disable max-len */
import { Link,Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  DescriptionTypography,
  PrivacyStack, SubTitleTypography, TextContent, TitleTypography
} from "./Privacy.styles";
import { BoxCorners, GridMain } from "../../components";
import { useAuthStore } from "../../stores";

export function PrivacyPage() {
  const theme = useTheme();
  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  setSpinnerLoginVisible(false);
  return (
    <>        
      <GridMain
        sx={ {
          margin: theme.spacing(10, 0),
          position:"relative",
          [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(0, 0)
          }
        } }

      >
        <BoxCorners $filled={ true } $cornersPosition={ "topRight" } />
        <BoxCorners $filled={ true } $cornersPosition={ "bottomLeft" } />
        <PrivacyStack >
          <Typography
            margin={ "0 auto" }
            sx={ {
              display: "flex",
              flexDirection: "column",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: "700",
              gap: "16px",
              lineHeight: "30px",
              marginBottom: "80px",
              textAlign: "center",
              top:"120px",
              [theme.breakpoints.down("sm")]: {
                fontSize:"16px",
                lineHeight: "21px",
                marginBottom: "40px"
              }
            } }
          >
            { "INFORMATIVA PRIVACY" } <br></br> 
            { "AI SENSI DEL REGOLAMENTO UE 2016/679 (GDPR)" } 
          </Typography>
          <TextContent>
            <DescriptionTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  fontSize:"14px",
                  lineHeight: "18px"
                }
              } }
            >
              { "Nel presente documento sono esposte le modalità di gestione della presente piattaforma relativamente al trattamento dei dati personali degli Utenti che utilizzano e/o interagiscono con la piattaforma." } <br></br> { "La presente informativa è resa esclusivamente per il trattamento di dati effettuato mediante la presente piattaforma e non anche per altri siti web o piattaforme/sezioni/pagine/spazi di titolarità di Terzi, eventualmente consultati dall’Utente tramite appositi link presenti sulla piattaforma." }
            </DescriptionTypography>
            <TitleTypography 
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } }>
              { "SEZIONE 1 – TITOLARE DEL TRATTAMENTO" }
            </TitleTypography>
            <DescriptionTypography
              sx={ {
                flexDirection: "column",
                gap:"0px",
                justifyContent: "initial",
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(3)
                }
              } }
            >
              <span>
                { "Il Titolare del trattamento è la società Digit’Ed S.p.A. (P. I. 07490560633) a socio unico, soggetta a direzione e coordinamento di Digit’Ed Holding S.p.A., in persona del legale rappresentante pro tempore, con sede legale in Via San Vigilio 1 - 20142, Milano indirizzo di posta elettronica: " }
                <Link color= { theme.customColors.textPrimaryCta }
                  href="email:privacy@digited.it"
                  target="_blank"
                >
                  privacy@digited.it 
                </Link> 
                { " (di seguito anche “Digit’Ed” o Società”)." }
              </span>             
            </DescriptionTypography>
            <TitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } }>
              { "SEZIONE 2 – RESPONSABILE DELLA PROTEZIONE DEI DATI (“RPD”)" }
            </TitleTypography>
            <DescriptionTypography
              sx={ {
                flexDirection: "column",
                gap:"0px",
                justifyContent: "initial",
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(3)
                }

              } }
            >
              { "Digit’Ed ha nominato un Responsabile della protezione dei dati (“RPD”), che è raggiungibile attraverso i seguenti canali di contatto:" }
              <ul>
                <li>Indirizzo di posta elettronica: <Link color= { theme.customColors.textPrimaryCta }
                  href="email:dpo@digited.it"
                  target="_blank"
                >
                  dpo@digited.it
                </Link>;
                </li>
                <li>
                  Posta ordinaria: Digit’Ed – Responsabile della Protezione dei Dati, Via Cechov Antonio, 50/5, 20151 Milano.
                </li>
              </ul>
            </DescriptionTypography>
            <TitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } }
            >
              { "SEZIONE 3 – TIPOLOGIA DEI DATI PERSONALI TRATTATI, FINALITA’ E BASE GIURIDICA DEL TRATTAMENTO" }
            </TitleTypography>
            <SubTitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(1)
                }
              } }>
              { "Dati personali comuni" }
            </SubTitleTypography>
            <DescriptionTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } }>
              { "La fruizione dei contenuti digitali presenti sulla piattaforma da parte dell’Utente comporta il trattamento dei dati anagrafici e di contatto dell’Utente (es. Nome, Cognome, User ID, Indirizzo email), nonché di altri dati personali eventualmente comunicati attraverso l’utilizzo della piattaforma (es. tramite commenti, compilazione di form, ecc.). In questo caso, i dati personali forniti dall’Utente verranno trattati per consentire l’utilizzo della piattaforma e la fruizione dei corsi, ai sensi dell’art. 6 par. 1 lett. b) GDPR. Con riferimento ai dati di soggetti terzi eventualmente comunicati, Digit’Ed informa che l’Utente si pone quale autonomo Titolare del trattamento, garantendo di essere legittimato alla comunicazione di tali dati e conferendo la più ampia manleva rispetto ad ogni contestazione, pretesa e/o richiesta di risarcimento del danno che dovesse pervenire al Titolare da tali terzi soggetti i cui dati personali siano stati trattati attraverso le sue richieste in violazione della normativa applicabile. " }
            </DescriptionTypography>
            <SubTitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(1)
                }
              } }
            >
              { "Dati di navigazione e fruizione" }
            </SubTitleTypography>
            <DescriptionTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } }
            >
              { "I sistemi informatici e le procedure software preposte al funzionamento di questa piattaforma acquisiscono, tramite standard xAPI e protocollo SCORM nel corso del loro normale esercizio e per la sola durata della connessione, alcuni dati personali la cui trasmissione è implicita nell’uso dei protocolli di comunicazione di Internet (cd. dati di navigazione). Si tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi, permettere di identificare gli Utenti.In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer utilizzati dagli Utenti che si connettono al Sito, gli indirizzi in notazione URI (Uniform Resource Identifier) delle risorse richieste, l’orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal server (buon fine, errore, ecc.), dati inerenti alla fruizione dei corsi (es. tempo di permanenza sulla piattaforma) e parametri relativi al sistema operativo e all’ambiente informatico dell’Utente. Ulteriori dati di fruizione dei corsi possono essere altresì raccolti tramite content provider esterni (ad es. Linkedin Learning), laddove l’utente acceda ai corsi presenti sulla presente piattaforma ma erogati su strumenti di content provider esterni. I dati sopra menzionati vengono utilizzati al fine di rendere possibile la fruizione della piattaforma da parte dell’Utente e gestire le sue richieste ai sensi dell’art. 6, par. 1, lett. b) GDPR. Si evidenzia, inoltre, che i predetti dati possono essere trattati anche al fine di ricavare informazioni statistiche sull'uso della piattaforma per controllarne il corretto funzionamento, per finalità di analisi e reportistica e per l'accertamento di responsabilità in caso di reati informatici ai danni della piattaforma o di altri siti web ad essa connessi o collegati. Per tali finalità, i dati sono trattati ai sensi dell’art.6, par. 1, lett. f) GDPR per il perseguimento del legittimo interesse del Titolare del trattamento al monitoraggio del funzionamento della piattaforma nonché alla difesa di un diritto in sede giudiziale e stragiudiziale." }
            </DescriptionTypography>
            <SubTitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(1)
                }
              } } >
              { "Cookie e strumenti di tracciamento." }
            </SubTitleTypography>
            <DescriptionTypography
              sx={ {
                display: "unset",
                flexDirection: "initial",
                gap:"0px",
                justifyContent: "initial",
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(3)
                }
              } }
            >
              { "Per maggiori informazioni sui cookie e strumenti di tracciamento attivi sul Sito si rinvia alla cookie policy consultabile al seguente " }
              <Link color= { theme.customColors.textPrimaryCta }
                href="/cookie"
                target="_blank"
                padding={ "0px" }>
                link
              </Link>.
            </DescriptionTypography>
            <TitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } } >
              { "SEZIONE 4 – DESTINATARI DEI DATI PERSONALI" }
            </TitleTypography>
            <DescriptionTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(3)
                }
              } }>
              { "I Suoi dati verranno trattati da dipendenti e/o collaboratori del Titolare, appositamente autorizzati e vincolati alla riservatezza e non verranno diffusi. Nei limiti del perseguimento delle finalità sopra indicate potrebbe essere necessario che alcune tipologie di soggetti esterni (es. fornitori di servizi informatici, tra cui sviluppo e gestione software, consulenti, professionisti, fornitori di servizi formativi e/o content provider, ecc.), operanti all’interno dell’Unione Europea, abbiano accesso ai dati degli Utenti in qualità di Responsabili del Trattamento ex art. 28 GDPR e/o Titolari autonomi. L’elenco aggiornato di tali soggetti può essere richiesto in qualsiasi momento al Titolare del trattamento o al RPD utilizzando i contatti riportati rispettivamente alle Sezioni 1 e 2 della presente informativa." }
            </DescriptionTypography>
            <TitleTypography 
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } }>
              { "SEZIONE 5 – TRASFERIMENTO DEI DATI PERSONALI AD UN PAESE TERZO" }
            </TitleTypography>
            <DescriptionTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(3)
                }
              } }>
              { "I dati personali dell’Utente verranno trattati esclusivamente all’interno del territorio dell’Unione Europea e non verranno trasferiti verso un Paese terzo o un’organizzazione internazionale." }
            </DescriptionTypography>
            <TitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } } >
              { "SEZIONE 6 – MODALITA’ DI TRATTAMENTO E PERIODO DI CONSERVAZIONE DEI DATI" }
            </TitleTypography>
            <DescriptionTypography
              sx= { {
                display: "unset",
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(3)
                }
              } }>
              { "Il Titolare tratta i dati personali dell’Utente adottando idonee misure di sicurezza per impedire l'accesso non autorizzato, la divulgazione, la modifica o la distruzione non autorizzata dei dati. I dati personali dell’Utente verranno trattati mediante strumenti manuali, informatici e telematici, nel pieno rispetto del principio di proporzionalità del trattamento, in base al quale i medesimi dati e le varie modalità del loro trattamento sono pertinenti e non eccedenti rispetto alle finalità perseguite. I dati personali dell’Utente verranno conservati per un periodo di tempo non superiore a quello necessario al conseguimento delle finalità per le quali essi sono trattati, fatti salvi i termini di conservazione previsti dalla legge (ad es. normativa in materia di conservazione relativa alla formazione obbligatoria) e, in ogni caso, per un periodo di conservazione non superiore ai 10 anni dall’erogazione del corso. Per i tempi di conservazione dei dati raccolti tramite cookie e altri strumenti di tracciamento, si rinvia a quanto indicato nella " }
              <Link color= { theme.customColors.textPrimaryCta }
                href="/cookie"
                target="_blank"
                padding={ "0px" }>
                cookie policy
              </Link>.
            </DescriptionTypography>
            <TitleTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(2)
                }
              } } >
              { "SEZIONE 7 – DIRITTI DELL’INTERESSATO" }
            </TitleTypography>
            <DescriptionTypography
              sx={ {
                [theme.breakpoints.down("sm")]: {
                  paddingBottom: theme.spacing(4)
                }
              } }>
              { "L’Utente potrà esercitare, in qualsiasi momento, nei confronti del Titolare i seguenti diritti previsti dagli artt. 15, 16, 17, 18, 20 e 21 del GDPR: - il diritto di accesso, che gli consente di ottenere dal Titolare la conferma che sia o meno in corso un trattamento dei suoi dati personali e, in tal caso, di ottenere l'accesso a tali dati;	- il diritto di rettifica, che gli consente di ottenere dal Titolare la rettifica e/o l’integrazione dei suoi dati personali che risultino inesatti e/o incompleti;	- il diritto alla cancellazione, che gli consente, in specifici casi previsti dall’art. 17 del Regolamento, di ottenere dal Titolare la cancellazione dei suoi dati personali;	- il diritto di limitazione di trattamento, che gli consente, nelle specifiche ipotesi previste dall’art. 18 del Regolamento, di limitare il trattamento dei suoi dati personali da parte del Titolare;	- il diritto di opposizione, che gli consente di opporsi al trattamento dei suoi dati personali al ricorrere di particolari condizioni;	- il diritto alla portabilità dei dati, che gli consente, in determinati casi e rispetto ai soli dati dallo stesso forniti, di poter chiedere la ricezione dei suoi dati personali in un formato strutturato, di uso comune e leggibile da dispositivo automatico." }
            </DescriptionTypography>
            <DescriptionTypography 
              sx = { { 
                display: "unset",
                gap: "0"
              } }
            >
              { "Per l’esercizio dei diritti di cui alla presente Sezione, l’Utente potrà indirizzare le proprie richieste, in qualsiasi momento, al RPD all’indirizzo di posta elettronica " }
              <Link color= { theme.customColors.textPrimaryCta }
                href="email:dpo@digited.it"
                target="_blank"
              >
                dpo@digited.it
              </Link>. <br></br>
              { "Avverso al trattamento illecito dei suoi dati personali, l’Utente ha inoltre il diritto di proporre reclamo all’Autorità Garante per la Protezione dei dati personali competente o di rivolgersi all’Autorità giudiziaria. " }
            </DescriptionTypography>         
            <Typography
              sx={ {
                display: "flex",
                flexDirection: "column",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 400,
                gap:"32px",
                justifyContent: "center",
                lineHeight: "21px",
                paddingTop: "24px",
                textAlign:"right",
            
                [theme.breakpoints.down("sm")]: {
                  fontSize: "12px",
                  margin: theme.spacing(1, 0)
      
                }
              } }>
              { "Ultimo aggiornamento: dicembre 2023" }
            </Typography>
          </TextContent>
        </PrivacyStack>
      </GridMain>
    </>
  );
}
